import React, { useEffect, useState, useRef } from 'react';
import {
  Tooltip,
  IconButton,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Badge,
 
} from '@chakra-ui/react';
import NotificationsIcon from '@mui/icons-material/Notifications'; // MUI icon for notifications
import { styled } from '@mui/material/styles'; // For customizing styles

const WebSocketNotification = ({ onNewNotification }) => {
  const [notificationCount, setNotificationCount] = useState(0); // Count of new notifications
  const [notifications, setNotifications] = useState([]); // Store notifications
  const [authTokens] = useState(() =>
    localStorage.getItem("authTokens")
      ? JSON.parse(localStorage.getItem("authTokens"))
      : null
  );
  const wsRef = useRef(null); // WebSocket instance reference
  const [retryAttempt, setRetryAttempt] = useState(0); // Track retry attempts

  // const token = authTokens?.access;
  // const wsUrl = `ws://127.0.0.1:8000/ws/notification/?token=${token}`;

  // const connectWebSocket = () => {
  //   if (!wsRef.current && token) {
  //     const ws = new WebSocket(wsUrl);
  //     wsRef.current = ws;

  //     ws.onopen = () => {
  //       console.log('WebSocket connection opened');
  //       setRetryAttempt(0); // Reset retry attempts on successful connection
      
  //     };

  //     ws.onmessage = (event) => {
  //       const data = JSON.parse(event.data);
  //       console.log('WebSocket message received:', data);
  //       if (data.message) {
  //         setNotificationCount((prevCount) => prevCount + 1); // Increase notification count
  //         setNotifications((prevNotifications) => [...prevNotifications, data.message]); // Add notification to the list
          
  //         // Call the onNewNotification prop function to handle new notification
  //         if (onNewNotification) {
  //           onNewNotification(data.message); // Pass notification to parent (DesktopNavigation)
  //         }
  //       }
  //     };

  //     ws.onclose = (event) => {
  //       console.log('WebSocket connection closed with code', event);
  //       wsRef.current = null; // Clear the WebSocket reference
  //       if (event.code === 1001 || event.code !== 1000) {
  //         // Try to reconnect after a delay if it's an abnormal closure
  //         setTimeout(() => {
  //           setRetryAttempt((prev) => prev + 1);
  //           connectWebSocket(); // Reconnect logic
  //         }, Math.min(1000 * retryAttempt, 10000)); // Exponential backoff up to 10 seconds
  //       }
  //     };

  //     ws.onerror = (error) => {
  //       console.log('WebSocket error:', error);
  //     };
  //   }
  // };

  // useEffect(() => {
  //   connectWebSocket();

  //   // Cleanup WebSocket on component unmount
  //   return () => {
  //     if (wsRef.current) {
  //       wsRef.current.close();
  //     }
  //   };
  // }, [token]);

  // Styled Notification Icon to be white
  const WhiteNotificationsIcon = styled(NotificationsIcon)({
    color: '#FFFFFF',
    // Set the icon color to white
  });

  return (
    <Menu>
      {/* Notification icon button with tooltip and badge */}
      <Tooltip label={`Notifications`} aria-label="notifications">
        <MenuButton
          as={IconButton}
          size="large"
          aria-label={`show ${notificationCount} new notifications`}
          color="inherit"
        >
          <Badge badgeContent={notificationCount} color="red">
            <WhiteNotificationsIcon />  
          </Badge>
        </MenuButton>
      </Tooltip>

      {/* Dropdown menu for displaying notifications */}
      <MenuList
        zIndex={10}
        maxW="300px"
        borderRadius="md"
        borderWidth="1px"
        borderColor="gray.200"
        bg="white"
        p={2}
      >
        {notifications.length === 0 ? (
          <MenuItem isDisabled>No new notifications{notificationCount}</MenuItem>
        ) : (
          notifications.map((notification, index) => (
            <MenuItem key={index} p={2} borderRadius="md" borderWidth="0.1px" borderColor="gray.200"sx={{ color: 'black' }}>
              {notification
                
              
              }
           
              
            
            </MenuItem>
          ))
        )}
      </MenuList>
    </Menu>
  );
};

export default WebSocketNotification;
